import React, { useEffect, useState } from "react";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { PurchaseHistoryLoadingSkeleton } from "../home/AllCategory/Skeleton";
import { toast, ToastContainer } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { MyContextSupply } from "../../Context";
import axios from "axios";

const PurchaseDetails = ({
  account,
  setIsShippingPopUpOpen,
  setisProductDetailsPopUpOpen,
  setShippingDetails,
  setProductDetails,
}) => {
  const { token } = MyContextSupply();
  const [loadingHistory, setLoadingHistory] = useState(true);
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [run, setRun] = useState(false);

  const toggleRun = () => {
    setRun((prev) => !prev);
  };
  // console.log(purchaseHistory);
  // console.log(token);
  const getPurchaseHistoryData = async () => {
    setLoadingHistory(true);
    return axios
      .get("https://stechbackend-9r4c.onrender.com/getpurchasehistory", {
        headers: { Authorization: token },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 201) {
          setPurchaseHistory(res.data);
          setLoadingHistory(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getPurchaseHistoryData();
  }, [run]);
  // console.log(purchaseHistory);
  const DeleteThisHistory = async (id) => {
    return await axios
      .post(
        "https://stechbackend-9r4c.onrender.com/deletesinglehistory/" + id,
        {},
        {
          headers: { Authorization: token },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.status === 201) {
          console.log("History deleted ");
          toggleRun();
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <>
      {loadingHistory ? (
        <PurchaseHistoryLoadingSkeleton />
      ) : (
        <div className="purchase-box">
          <h3 className="purchase-history-h3">Purchase History</h3>
          {purchaseHistory?.purchasehistory?.length === 0 ? (
            <h1>You haven't bought anything to show in the history!</h1>
          ) : (
            <div className="table-history-show">
              <table>
                <thead>
                  <tr className="its-head-table">
                    <th>Purchase Date</th>
                    <th>Quantity</th>
                    <th>Total Price($)</th>
                    <th>Shipping Info</th>
                    <th>Product Details</th>
                    <th>Delete this history</th>
                  </tr>
                </thead>

                {purchaseHistory.purchasehistory.map((singleValues, index) => {
                  const {
                    totalItem,
                    totalPrice,
                    createdAt,
                    cartItems,
                    isDelivered,
                    _id,
                  } = singleValues;
                  // console.log(singleValues);
                  const dt = new Date(createdAt).toLocaleString();
                  return (
                    <tbody key={index}>
                      <tr>
                        <td>{dt}</td>
                        <td>{totalItem}</td>
                        <td>{totalPrice}</td>
                        <td>
                          <button
                            onClick={() => {
                              setIsShippingPopUpOpen(true);
                              setShippingDetails(singleValues);
                            }}
                            className={`shipping-details-td shipping-track ${
                              isDelivered && "shippin-track-delivered"
                            }`}
                          >
                            <LocalShippingIcon />
                            {isDelivered ? (
                              <FaCheckCircle className="icon-Check-shipping-track" />
                            ) : (
                              <IoMdCloseCircleOutline className="icon-Check-shipping-track" />
                            )}
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              setisProductDetailsPopUpOpen(true);
                              setProductDetails(cartItems);
                            }}
                            className="shipping-details-td"
                          >
                            Check
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              DeleteThisHistory(_id);
                              // console.log(_id);
                            }}
                            className="shipping-details-td"
                          >
                            <DeleteForeverIcon
                              style={{ color: "red" }}
                              className="delete-history"
                            />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            </div>
          )}
          <ToastContainer />
        </div>
      )}
    </>
  );
};

export default PurchaseDetails;
